module.exports = __webpack_public_path__ + "img/ego.4892e934.jpg";